export class ServiceGroupQueryParameters {
  categoryId?: string;
  chargeoutRateBasisId?: string;
  expired?: string;
  embed?: any;
  id?: string;
  page?: number;
  pageSize?: number;
  preDeliveryInspectionFlag?: string;
  rooftopId?: string;
  search?: string;
  standardOpCodeFlag?: string;
  standardOpCodeServiceGroupId?: string;
  subletFlag?: string;
  technicianGroupId?: string;
  technicianRateBasisId?: string;
  useFlag?: string;
  warrantySubmissionTypeId?: string;
  workOrderLocationOpCode?: string;

  constructor(obj?: ServiceGroupQueryParameters) {
    if (obj) {
      Object.assign(this, obj);
    }
  }
}
